import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Form, Input, Modal, Switch } from 'antd'
import { DISCORD_WEBHOOK_REGEX } from '../../../../../../modules/brandActivityTransaction'

const WebhookForm = (props) => {
  const { visible, formState, loading, onOk, onCancel, form } = props
  const { getFieldDecorator, validateFields, resetFields } = form
  const isEdit = !!formState
  const record = formState || {}

  useEffect(() => {
    if (visible) {
      resetFields()
    }
  }, [visible, formState])

  const onSubmit = () => {
    validateFields((err, values) => {
      if (!err) {
        const body = {}
        const name = values.name ? values.name.trim() : ''
        const url = values.url.trim()
        // แก้ไข: ส่งเฉพาะ field ที่เปลี่ยน
        if (!isEdit || name !== (record.name || '')) body.name = name
        if (!isEdit || url !== record.url) body.url = url
        if (!isEdit || values.enabled !== record.enabled) body.enabled = values.enabled
        onOk(body)
      }
    })
  }

  return (
    <Modal
      title={`${isEdit ? 'แก้ไข' : 'เพิ่ม'} Webhook`}
      visible={visible}
      onOk={onSubmit}
      onCancel={onCancel}
      confirmLoading={loading}
      okText="บันทึก"
      cancelText="ยกเลิก"
      maskClosable={false}>
      <Form layout="vertical">
        <Form.Item label="ชื่อ">
          {getFieldDecorator('name', {
            initialValue: record.name || undefined,
            rules: [{ max: 100, message: 'ชื่อต้องไม่เกิน 100 ตัวอักษร' }]
          })(<Input placeholder="เช่น ทีมแบรนด์ X" />)}
        </Form.Item>
        <Form.Item label="Discord Webhook URL">
          {getFieldDecorator('url', {
            initialValue: record.url || undefined,
            rules: [
              { required: true, whitespace: true, message: 'กรุณากรอก URL' },
              {
                validator: (rule, value, callback) => {
                  if (value && !DISCORD_WEBHOOK_REGEX.test(value.trim())) {
                    callback('URL Discord webhook ไม่ถูกต้อง')
                  } else {
                    callback()
                  }
                }
              }
            ]
          })(
            <Input
              autoComplete="off"
              placeholder="https://discord.com/api/webhooks/<id>/<token>"
            />
          )}
        </Form.Item>
        <Form.Item label="เปิดใช้งาน">
          {getFieldDecorator('enabled', {
            initialValue: isEdit ? !!record.enabled : true,
            valuePropName: 'checked'
          })(<Switch />)}
        </Form.Item>
      </Form>
    </Modal>
  )
}

WebhookForm.propTypes = {
  visible: PropTypes.bool.isRequired,
  formState: PropTypes.object,
  loading: PropTypes.bool,
  onOk: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
}

const WrappedWebhookForm = Form.create({ name: 'BrandActivityWebhookForm' })(
  WebhookForm
)
export default WrappedWebhookForm
